<template>
    <kiosk-team-details :teamId="props.teamId">
        <div class="flex flex-col w-full max-w-(--breakpoint-sm) justify-center">
            <page-callout section="kiosk-team-billing-config" class="mb-4" />

            <page-header>Billing Config</page-header>

            <kiosk-team-payment-terms-card
                v-if="team"
                :team="team"
                :teamId="props.teamId"
                @updated="handlePaymentTermsUpdated"
            />

            <kiosk-team-pricing-card v-if="team" :team="team" :teamId="props.teamId" />
        </div>
    </kiosk-team-details>
</template>

<script setup>
import KioskTeamDetails from '~/components/kiosk/kiosk-teams/details/KioskTeamDetails.vue';
import PageHeader from '~/components/general/PageHeader.vue';
import PageCallout from '~/components/general/PageCallout.vue';
import { useTeamDetails } from '~/components/kiosk/kiosk-teams/composables/useTeamDetails';
import KioskTeamPaymentTermsCard from '~/components/kiosk/kiosk-teams/cards/KioskTeamPaymentTermsCard.vue';
import KioskTeamPricingCard from '~/components/kiosk/kiosk-teams/cards/KioskTeamPricingCard.vue';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});

const { team, refreshTeam } = useTeamDetails();

const handlePaymentTermsUpdated = async () => {
    await refreshTeam(props.teamId);
};
</script>
